import { DataHeader, DataSource, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutJobClassification extends Layout {
    dataheaderJobClassification: DataHeader;
    lookupDivisionId: Textbox;
    lookupHolidayPayAccountId: Textbox;
    lookupJobClassCodeId: Textbox;
    lookupOvertimePayAccountId: Textbox;
    lookupRegularPayAccountId: Textbox;
    lookupSickPayAccountId: Textbox;
    lookupTerminalId: Textbox;
    lookupVacationPayAccountId: Textbox;
    sourceDivisionLookup: DataSource;
    sourceJobClassCodeLookup: DataSource;
    sourceJobClassification: DataSource;
    sourceTerminalLookup: DataSource;
    tabGeneral: Tab;
    tabWageGLAccounts: Tab;
    tabWorkersCompensation: Tab;
    tabsetJobClassification: Tabset;
    textboxMaximumAmount: Textbox;
    textboxOvertimePayPercent: Textbox;
    textboxRegularPayPercent: Textbox;
}
